// Exemplos de GET /api/messages/:id/status (consulta do status de uma
// mensagem enviada pelo canal Oficial) mostrados na tela /messages-api.
//
// Módulo puro de propósito: o spec __tests__/statusExamples.test.js valida cada
// snippet mecanicamente (JSON.parse, @babel/parser, php -l, compile() do
// Python) sem montar React. Mudou o contrato da rota? Atualize aqui TODAS as
// linguagens com o valor completo — nunca só um comentário.
//
// `response` é descrição de campo (i18n, resolvida na chamada, no idioma
// atual); `copy` e `examples` são código, iguais em qualquer idioma.
import { i18n } from "../../translate/i18n";

const TOKEN = "SEU_TOKEN";
const ORIGEM = "ERP Financeiro";
const MESSAGE_ID = 4821;

export const buildStatusExamples = (baseUrl = "") => {
  const url = `${baseUrl}/api/messages/${MESSAGE_ID}/status`;

  const status = {
    method: "GET",
    url: `${baseUrl}/api/messages/:messageId/status`,
    lines: [],
    response: i18n.t("messagesAPIInstructions.statusResponse"),
    copy: [
      `GET ${url}`,
      `Authorization: Bearer ${TOKEN}`,
      `X-Origin: ${ORIGEM}`,
    ].join("\n"),
    examples: {
      curl: `curl "${url}" \\
  -H "Authorization: Bearer ${TOKEN}" \\
  -H "X-Origin: ${ORIGEM}"
# messageId vem da resposta do POST /api/messages/send (conexão oficial); se
# vier null, não há status a consultar.
# 200 (entregue) => { "messageId": 4821, "wid": "wamid.HBgMNTU4NTk5OTk5OTk5FQIAERgS",
#   "status": "delivered", "ack": 2, "failure": null }
# 200 (falhou)   => { "messageId": 4821, "wid": "wamid.HBgMNTU4NTk5OTk5OTk5FQIAERgS",
#   "status": "failed", "ack": -1, "failure": { "code": 131042, "category": "conta",
#   "reason": "A conta do WhatsApp Business tem pagamento pendente na Meta",
#   "action": "Regularize no Meta Business para voltar a enviar",
#   "link": "https://business.facebook.com/billing_hub/payment_settings",
#   "reasonOriginal": "[131042] Business eligibility payment issue" } }
# 404 => { "error": "ERR_NO_MESSAGE_FOUND" } (id inexistente, de outra empresa
# ou de mensagem de outra conexão)`,
      node: `const axios = require("axios");

(async () => {
  const { data } = await axios.get("${url}", {
    headers: { Authorization: "Bearer ${TOKEN}", "X-Origin": "${ORIGEM}" },
  });

  // data.status: "accepted" | "sent" | "delivered" | "read" | "failed"
  if (data.status === "failed") {
    // category: conta | contato | janela | template | limite | midia | desconhecido
    console.error(data.failure.category, data.failure.reason);
    console.error(data.failure.action, data.failure.link);
  }
})();`,
      ts: `type StatusDaMensagem = {
  messageId: number;
  wid: string | null;
  status: "accepted" | "sent" | "delivered" | "read" | "failed";
  ack: number; // 0/1 enviada, 2 entregue, 3 lida, -1 = falhou
  failure: {
    code: number | null;
    category:
      | "conta"
      | "contato"
      | "janela"
      | "template"
      | "limite"
      | "midia"
      | "desconhecido";
    reason: string; // motivo em português
    action: string; // o que fazer para resolver
    link: string | null; // página de correção na Meta, quando existe
    reasonOriginal: string | null; // texto original da Meta
  } | null; // null enquanto a mensagem não falhou
};

const resposta = await fetch("${url}", {
  headers: { Authorization: "Bearer ${TOKEN}", "X-Origin": "${ORIGEM}" },
});

const situacao: StatusDaMensagem = await resposta.json();
if (situacao.status === "failed" && situacao.failure) {
  console.error(situacao.failure.category, situacao.failure.reason);
}`,
      php: `<?php
$ch = curl_init("${url}");
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
curl_setopt($ch, CURLOPT_HTTPHEADER, [
    "Authorization: Bearer ${TOKEN}",
    "X-Origin: ${ORIGEM}",
]);
$situacao = json_decode(curl_exec($ch), true);
curl_close($ch);

// $situacao["status"]: accepted | sent | delivered | read | failed
if ($situacao["status"] === "failed") {
    // category: conta | contato | janela | template | limite | midia | desconhecido
    error_log($situacao["failure"]["category"] . ": " . $situacao["failure"]["reason"]);
    error_log($situacao["failure"]["action"] . " " . $situacao["failure"]["link"]);
}`,
      python: `import requests

resposta = requests.get(
    "${url}",
    headers={"Authorization": "Bearer ${TOKEN}", "X-Origin": "${ORIGEM}"},
)
situacao = resposta.json()

# situacao["status"]: accepted | sent | delivered | read | failed
if situacao["status"] == "failed":
    # category: conta | contato | janela | template | limite | midia | desconhecido
    falha = situacao["failure"]
    print(falha["category"], falha["reason"])
    print(falha["action"], falha["link"])`,
    },
  };

  return { status };
};

export default buildStatusExamples;
